import { Bell, Check } from "lucide-react";

export const DEFAULT_NOTIFICATION_PREFERENCES = {
  newsletter: false,
  blog_posts: false,
  poems: false,
  new_songs: false,
  live_streams: false,
  streaming_interface: false,
  creator_opportunities: false,
};

const NOTIFICATION_OPTIONS = [
  {
    key: "creator_opportunities",
    title: "Creator Opportunities",
    description: "Updates about upcoming creator programs and opportunities.",
  },
  {
    key: "newsletter",
    title: "Newsletter",
    description: "Occasional news, announcements, and updates.",
  },
  {
    key: "blog_posts",
    title: "Blog Posts",
    description: "Get notified when new articles are published.",
  },
  {
    key: "poems",
    title: "Poetry",
    description: "Updates when new poems are released.",
  },
  {
    key: "new_songs",
    title: "New Music",
    description: "Hear about new songs and music releases.",
  },
  {
    key: "live_streams",
    title: "Live Streams",
    description: "Updates about streams on Twitch, TikTok, YouTube, and Kick.",
  },
  {
    key: "streaming_interface",
    title: "Streaming Interface",
    description: "News about the free creator streaming interface.",
  },
];

export default function NotificationPreferences({
  value,
  onChange,
  disabled = false,
}) {
  const togglePreference = (key) => {
    if (disabled) return;

    onChange({
      ...value,
      [key]: !value[key],
    });
  };

  return (
    <section className="space-y-4">
      <div className="flex items-center gap-3">
        <Bell size={20} className="text-matrix-orange" />

        <div>
          <h3 className="font-display text-xl text-white">
            CHOOSE YOUR UPDATES
          </h3>

          <p className="mt-1 text-xs text-white/50">
            Select what interests you. Everything is optional.
          </p>
        </div>
      </div>

      <div className="grid gap-3">
        {NOTIFICATION_OPTIONS.map((option) => {
          const selected = Boolean(value[option.key]);
          const featured = option.key === "creator_opportunities";

          return (
            <label
              key={option.key}
              className={`
                flex cursor-pointer items-start gap-4
                border p-4 transition-colors
                ${
                  selected
                    ? "border-matrix-orange/60 bg-matrix-orange/10"
                    : featured
                      ? "border-matrix-orange/30 bg-matrix-orange/[0.04] hover:border-matrix-orange/50"
                      : "border-white/10 bg-white/[0.02] hover:border-white/30"
                }
                ${disabled ? "cursor-not-allowed opacity-50" : ""}
              `}
            >
              <input
                type="checkbox"
                checked={selected}
                disabled={disabled}
                onChange={() => togglePreference(option.key)}
                className="sr-only"
              />

              <span
                aria-hidden="true"
                className={`
                  mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center
                  border
                  ${
                    selected
                      ? "border-matrix-orange bg-matrix-orange text-black"
                      : "border-white/40"
                  }
                `}
              >
                {selected && <Check size={14} strokeWidth={3} />}
              </span>

              <span className="block">
                <span className="block text-sm font-semibold text-white">
                  {option.title}
                </span>

                <span className="mt-1 block text-xs leading-relaxed text-white/50">
                  {option.description}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      <p className="text-xs leading-relaxed text-white/40">
        Your selections control which updates you agree to receive.
        You can change them later. Unselected categories remain off.
      </p>
    </section>
  );
}
